import {CHANGE_PRODUCT, START, SUCCESS, FAIL} from "../constants/action-types";
import {API_PRODUCT_INFO} from "../constants/api";
import Mediator from "../services/Mediator";
import ChangeProductCommand from "../services/lib/undo-redo/change-product-command";
import trackEvent from "../../../utils/track-event";
import {toggleStaticObjects} from "./toggle-static-objects";

export const changeProduct = (productName, silent) => (dispatch, getState) => {
  const {
    condition,
    designs,
    product,
    product: {
      id,
      meta: {pluralized_product: prevProductName}
    }
  } = getState();
  const callAPI = `${API_PRODUCT_INFO}/${productName}/new${
    id || product.raw_parent_id
      ? `?product_id=${id || product.raw_parent_id}`
      : ``
  }`;
  const sideIndex = product.meta.designs.reduce(
    (acc, item, i) => (item.side === product.meta.default_side ? i : acc),
    0
  );
  if (!silent) {
    Mediator.history.add(
      new ChangeProductCommand(prevProductName, productName, {
        changeProduct,
        dispatch,
        getState
      })
    );
  }
  dispatch({
    type: CHANGE_PRODUCT + START
  });
  return fetch(callAPI, {
    headers: {
      "Accept": `application/json`,
      "Content-Type": `application/json`
    },
    credentials: `same-origin`
  })
    .then((res) => {
      if (res.status >= 400) {
        throw new Error(`Error`);
      }
      return res.json();
    })
    .then((response) => {
      dispatch({
        type: CHANGE_PRODUCT + SUCCESS,
        response,
        payload: {
          prev: {
            condition,
            sideIndex
          },
          next: {
            design: designs[sideIndex].design
          }
        }
      });
      dispatch(toggleStaticObjects(condition));
      trackEvent({
        category: `Editor`,
        action: `Switch product`
      });
    })
    .catch((error) =>
      dispatch({
        type: CHANGE_PRODUCT + FAIL,
        error,
        payload: {
          prev: {
            condition,
            sideIndex
          },
          next: {
            design: designs[sideIndex].design
          }
        }
      })
    );
};
